module.exports = __webpack_public_path__ + "img/Maradona-7.4773f17d.webp";